import { Clipboard16, FacebookFilled24, TwitterFilled24 } from '@makyoapp/makyo-icon/icon'
import { CheckOrCross, SimpleInput } from '@makyoapp/makyo-ui'

import { WrapperProps } from '@/shared/routes'
import Layout from '@/components/Layout'
import { SaveButton } from '@/components/SaveButton'

import useMyReferral from './hooks/useMyReferral'

/**
 * My Referral page
 */
export default function UserMyReferral(props: WrapperProps) {
  const { isLoading, val, isValid, onSave, onInputChange, checkIsLoading, shareUri, handleCopyUri, t } = useMyReferral()

  return (
    <Layout title={props.title} actions={<SaveButton id='my-referral-save' isLoading={isLoading} onClick={onSave} />}>
      <div>
        <div className='mb-4'>{t('referralNote')}</div>
        <div className='mb-2 md:mb-0 md:flex md:items-center md:gap-2'>
          <div className='flex-c rtl:flex-row-reverse'>
            <span className='block rtl:[direction:ltr] mb-4 md:mb-0'>https://makyo.me/ref/</span>
            <div className='mb-4 md:mb-0'>
              <SimpleInput
                id='my-referral-code'
                className='rtl:[direction:ltr]'
                inputClassName='w-full'
                outlined={true}
                value={val}
                onChange={onInputChange}
                after={checkIsLoading ? <span className='loading spin' /> : <CheckOrCross value={isValid} />}
              />
            </div>
          </div>
          <div className='flex-c md:justify-center md:ltr:ml-4 md:rtl:mr-4 mb-8 md:mb-0'>
            <button className='p-2 rounded-full bg-primary-500 text-white' onClick={handleCopyUri}>
              <Clipboard16 width={24} height={24} />
            </button>
            <a
              className='p-2 rounded-full bg-primary-500 text-white'
              href={`https://facebook.com/sharer.php?u=${shareUri}`}
            >
              <FacebookFilled24 />
            </a>
            <a
              className='p-2 rounded-full bg-primary-500 text-white'
              href={`https://twitter.com/share?url=${shareUri}`}
            >
              <TwitterFilled24 />
            </a>
          </div>
        </div>
      </div>
    </Layout>
  )
}
